import type { ReactNode } from 'react';
import { MdLockOutline } from 'react-icons/md';

interface PresetTableShellProps {
  label: string;
  children: ReactNode;
  /** Hide the locked/editable legend for blocks with no editable cells (e.g. SRI). */
  showLegend?: boolean;
}

/** Shared layout wrapper for KID Figures preset blocks. */
export function PresetTableShell({
  label,
  children,
  showLegend = true,
}: PresetTableShellProps) {
  return (
    <div className="rounded-lg border border-emerald-200">
      <div className="flex flex-wrap items-center justify-between gap-2 rounded-t-lg border-b border-emerald-200 bg-emerald-50 px-3 py-2">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-800">{label}</span>
          <span className="rounded-full border border-emerald-300 bg-white px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700">
            KID Figures
          </span>
        </div>
        {showLegend && (
          <div className="flex items-center gap-3 text-[11px] text-gray-500">
            <span className="inline-flex items-center gap-1">
              <span className="inline-flex items-center gap-0.5 rounded bg-gray-100 px-1 py-0.5 text-gray-600">
                <MdLockOutline className="h-3 w-3 text-gray-400" aria-hidden />
              </span>
              auto-filled, read-only
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="h-3 w-5 rounded-sm border border-blue-200 bg-[var(--pastle-blue-lighter)]" />
              editable
            </span>
          </div>
        )}
      </div>
      <div className="overflow-x-auto p-3">{children}</div>
    </div>
  );
}
